import script from "./BlogSimilar.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogSimilar.vue?vue&type=script&lang=ts&setup=true"

import "./BlogSimilar.vue?vue&type=style&index=0&id=03924f42&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03924f42"]])

export default __exports__